export default __webpack_public_path__ + "static/media/John_DeLollis.680e2f2f.jpg";